import { displayDateTimeToMinute, Entity, FieldType, makeClone } from 'gossamer-unified';
import { Event, EventRow } from './Event';
// import { TicketItemWithBookings } from './types';

export type EventExtendedViewRow = EventRow & {
  first_start_at: string;
  first_end_at: string;
  ticket_data: string; // JSON string of TicketItemWithBookings[]
  groups: number[]; // ids of institution_groups linked via institution_group_event, in ascending order
  co_hosts: string[]; // user ids of registered co-hosts, excluding the main host, in the order added
  search_match_rank: number;
};

const clone = makeClone();

export const EventExtendedView: Entity<EventExtendedViewRow> = {
  id: 'EventExtendedView',
  title: 'Event',
  service: 'main',
  rowLabel: (row: EventExtendedViewRow) => `${row.title} (${displayDateTimeToMinute(row.start_at)})`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.event_extended_view',
  },
  security: Event.security,
  defaultSort: [['start_at', 'DESC']],
  defaultFilters: Event.defaultFilters,
  listRowLink: Event.listRowLink,
  fields: {
    id: clone(Event.fields.id),
    title: clone(Event.fields.title),
    start_at: clone(Event.fields.start_at),
    end_at: clone(Event.fields.end_at),

    // emergency backward-compatibility fixes
    first_start_at: clone(Event.fields.start_at),
    first_end_at: clone(Event.fields.end_at),

    type: clone(Event.fields.type),
    images: clone(Event.fields.images),
    institution_id: clone(Event.fields.institution_id),
    event_profile_id: clone(Event.fields.event_profile_id),
    main_host_user_id: clone(Event.fields.main_host_user_id),
    location_type: clone(Event.fields.location_type),
    location: clone(Event.fields.location),
    gps_location: clone(Event.fields.gps_location),
    visibility_limit: clone(Event.fields.visibility_limit),
    booking_method: clone(Event.fields.booking_method),
    booking_url: clone(Event.fields.booking_url),
    specialty_group: clone(Event.fields.specialty_group),
    specialties: clone(Event.fields.specialties),
    employment_grade: clone(Event.fields.employment_grade),
    year_group: clone(Event.fields.year_group),
    created_by: clone(Event.fields.created_by),
    created_at: clone(Event.fields.created_at),
    updated_at: clone(Event.fields.updated_at),
    markdown_description: clone(Event.fields.markdown_description),
    plain_description: clone(Event.fields.plain_description),
    attendance_token: clone(Event.fields.attendance_token),
    livestream_session_id: clone(Event.fields.livestream_session_id),
    feedback_form_id: clone(Event.fields.feedback_form_id),
    flow_option: clone(Event.fields.flow_option),
    search_vector: clone(Event.fields.search_vector),
    booking_payment_terms_id: clone(Event.fields.booking_payment_terms_id),
    repeat_pattern: clone(Event.fields.repeat_pattern),
    repeat_start_event_id: clone(Event.fields.repeat_start_event_id),
    repeat_group_id: clone(Event.fields.repeat_group_id),
    repeat_metadata: clone(Event.fields.repeat_metadata),
    ticket_data: {
      seq: 910,
      type: FieldType.Text,
      label: 'Ticket Data',
    },
    groups: {
      seq: 915,
      type: FieldType.Object,
      label: 'Groups',
    },
    co_hosts: {
      seq: 917,
      type: FieldType.Object,
      label: 'Co-Hosts',
    },
    search_match_rank: {
      seq: 920,
      type: FieldType.Decimal,
      label: 'Search Match Rank',
    },
  },
};
